import { TranslationKey } from "../../contexts/I18nContext/translationKeys";
import useTranslations from "../../hooks/useTranslations";
import SanitizedReactHtmlParser from "../../utils/SanitizedReactHtmlParser/SanitizedReactHtmlParser";

export interface TranslateProps {
  translationKey: TranslationKey | string;
  replacements?: Record<string, string | number>;
}

export default function Translate({
  translationKey,
  replacements,
}: TranslateProps): JSX.Element {
  const { getTranslation } = useTranslations();

  return <>{getTranslation(translationKey, replacements)}</>;
}

export const TranslateHtml = ({
  translationKey,
  parameters,
}: {
  translationKey: TranslationKey;
  parameters?: Record<string, string | number>;
}) => {
  const { getTranslation } = useTranslations();
  return (
    <SanitizedReactHtmlParser
      content={getTranslation(translationKey, parameters)}
    />
  );
};
